export const c_primary = '#3b4596';// blue strong
export const c_primary_l = "#c5e4ec";//blue light
export const c_secondary = '#265843';//purple 
export const c_background = '#fef7ef';//beige

/* "dalia-blue": "#3b4596",
"dalia-light-blue": "#c5e4ec",
"dalia-border-blue": "#8383e9",
"dalia-purple": "#c2a5cc",
"dalia-black": "#212121",
"dalia-pink": "#eaa9c2",
"dalia-green": "#265843",
"dalia-bg": "#fef7ef",
"dalia-course-bg": "#AB96EA33",
"dalia-section-bg": "#111827",
"dalia-card-bg": "#1F2937", */

//UserDetail
export const c_seccion = "#c2a5cc"; //headerseccion
export const c_disabled="#a8abb1"
export const c_error="#fcf2f1";
export const c_error_s="#d32f2f";

export const yellow="#343807";
export const yellow_back="#FAFBE5"
export const c_success="#096D2A";
export const c_success_back="#EDFEF2";
export const blue="#4069E5";
export const blue_back="#F1F4FD";

/** StatCards, cupones en gráfica Dalia */
export const stat_default_header = "#c5e4ec";
export const stat_default_accent = "#3b4596";
export const stat_b2c_header = "#e8f2ed";
export const stat_b2c_accent = "#265843";
export const stat_b2b_accent = "#3b4596";
export const stat_coupon_header = "#fffbeb";
export const stat_coupon_accent = "#f7df5b";
export const stat_coupon_title = "#2d2d2d";
export const stat_new_sub_header = "#f3edf8";
export const stat_new_sub_accent = "#c2a5cc";

export const dashboard_blue = "#3b4596";
export const dashboard_coupon = "#f7df5b";
export const dashboard_blue_soft = "#e8eaf5";
export const dashboard_coupon_soft = "#fffbeb";
/** @deprecated usar dashboard_coupon */
export const dashboard_coral = dashboard_coupon;
/** @deprecated usar dashboard_coupon_soft */
export const dashboard_coral_soft = dashboard_coupon_soft;
export const orange="#ED7D2D";
export const orange_back="#FEF6F1";
export const cyan="#00BDD6";
export const cyan_back="#EBFDFF";

